import styled from 'styled-components';
import { Flexer } from '@ontruck/orc';

export const StyledTopBar = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))`
  top: 0;
  left: 0;
  background: var(--primary-top-bar);
  border-bottom: var(--primary-top-bar-border);

  a {
    color: var(--primary-top-bar-color);
  }

  & .submenu {
    & button {
      border-color: var(--primary-top-bar-color);

      :hover {
        border-color: var(--primary-top-bar-color);
      }

      > span svg {
        fill: var(--primary-top-bar-color);
      }

      color: var(--primary-top-bar-color);
    }
  }

  z-index: 98;
`;
